import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { rootStore } from '../instance';

type SystemParamsStoreProps = {
  children: React.ReactNode;
};

const QueryParamsStoreInitializer: React.FC<SystemParamsStoreProps> = ({ children }) => {
  const { queryParamsStore } = rootStore;
  const { search } = useLocation();

  queryParamsStore.update(search);

  return <>{children}</>;
};

export default QueryParamsStoreInitializer;
